<!--
Chronological list view of a plan's entries, grouped by date. YYYY-MM-DD strings
sort lexically, so plain string sort gives date order.

<MealPlanEntryList
    :entries="plan.entries"
    v-on:remove-entry="entry_id => ..."
/>
-->
<template>
    <div class="entry_list">
        <p v-if="grouped.length < 1" class="empty_text">{{ $t('meal_plans.no_entries') }}</p>
        <div class="day_group" v-for="group in grouped" :key="group.date">
            <h3>{{ formatDay(group.date) }}</h3>
            <ul>
                <li v-for="entry in group.entries" :key="entry.id">
                    <span class="slot_tag" v-if="entry.slot">{{ $t('meal_plans.slots.' + entry.slot) }}</span>
                    <router-link :to="'/recipes/' + entry.recipe_id" class="no_extra_styling entry_name">{{ entry.recipe_id }}</router-link>
                    <span class="entry_servings" v-if="entry.servings">× {{ entry.servings }} {{ $t('meal_plans.servings').toLowerCase() }}</span>
                    <button type="button" class="remove_link" @click="$emit('remove-entry', entry.id)">{{ $t('meal_plans.remove_entry') }}</button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { parseLocalDate } from '@/utils/date.js';

const SLOT_ORDER = { breakfast: 0, lunch: 1, dinner: 2, snack: 3 };

export default {
    name: "MealPlanEntryList",
    props: [
        'entries'
    ],
    computed: {
        grouped() {
            let by_date = {};
            for (let entry of this.entries || []) {
                if (!by_date[entry.date]) {
                    by_date[entry.date] = [];
                }
                by_date[entry.date].push(entry);
            }
            return Object.keys(by_date).sort().map((date) => {
                let entries = by_date[date].sort((a, b) => {
                    let orderA = a.slot in SLOT_ORDER ? SLOT_ORDER[a.slot] : 4;
                    let orderB = b.slot in SLOT_ORDER ? SLOT_ORDER[b.slot] : 4;
                    return orderA - orderB;
                });
                return { date: date, entries: entries };
            });
        }
    },
    methods: {
        formatDay(date_string) {
            return parseLocalDate(date_string).toLocaleDateString('el-GR', { weekday: 'long', day: 'numeric', month: 'long' });
        }
    }
}
</script>

<style scoped>
.entry_list {
    text-align: left;
}
.day_group {
    margin-bottom: 1.5rem;
}
.day_group h3 {
    font-size: 1.1rem;
    border-bottom: var(--line-dashed);
    padding-bottom: 0.3rem;
}
ul {
    list-style: none;
    padding: 0;
}
li {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.4rem 0;
}
.slot_tag {
    font-size: 0.75rem;
    border: 1px solid var(--color-grey-1);
    border-radius: 50px;
    padding: 0.1rem 0.5rem;
    color: var(--color-grey-2);
}
.entry_name:hover {
    color: var(--color-secondary);
}
.entry_servings {
    color: var(--color-grey-2);
    font-size: 0.85rem;
}
.remove_link {
    background: none;
    border: none;
    margin-left: auto;
    color: var(--color-grey-2);
    font-size: 0.8rem;
    cursor: pointer;
    text-decoration: underline;
}
.remove_link:hover {
    color: var(--color-secondary);
}
.empty_text {
    color: var(--color-grey-2);
}
</style>
